import { IconButton, Link, Spinner, Stack } from "@fluentui/react";
import { RootState } from "app/store";
import CustomPanel from "components/controls/CustomPanel";
import InformationCallout from "components/controls/InformationCallout";
import LinkTo from "components/controls/LinkTo";
import SnapshotTimeline from "components/controls/SnapshotTimeline";
import * as IXrmOptionSet from "model/AttributeOptionSets.type";
import {
    bcbs_groupconfigurationsnapshot as IXrmTypes_bcbs_groupconfigurationsnapshot
} from "model/CRM";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const SnapshotDiscovery = () => {
    const state = useSelector((state: RootState) => state);

    const [loading, setLoading] = useState(false);

    const [links, setLinks] = useState<IXrmTypes_bcbs_groupconfigurationsnapshot[]>([]);

    useEffect(() => {
        (async () => {
            const snapshots: IXrmTypes_bcbs_groupconfigurationsnapshot[] = [];

            const discover = (snapshot: IXrmTypes_bcbs_groupconfigurationsnapshot, ttl: number) => {
                snapshots.push(snapshot);

                if (ttl > 255)
                    return;

                const originatingsnapshot = snapshot._bcbs_originatingsnapshotid_value
                    ? state.status.snapshots?.find(t => t.bcbs_groupconfigurationsnapshotid === snapshot._bcbs_originatingsnapshotid_value)
                    : undefined;

                if (originatingsnapshot)
                    discover(originatingsnapshot, ttl + 1);

                const originatingsnapshot2 = snapshot._bcbs_originatingsnapshot2id_value
                    ? state.status.snapshots?.find(t => t.bcbs_groupconfigurationsnapshotid === snapshot._bcbs_originatingsnapshot2id_value)
                    : undefined;

                if (originatingsnapshot2)
                    discover(originatingsnapshot2, ttl + 1);

            }

            discover(state.data.snapshot, 0);

            setLinks(snapshots)

            // if (snapshot._bcbs_originatingsnapshotid_value) {
            //     dataSource.getbcbs
            // }

        })();
    }, []);

    const [documentFile, setDocumentFile] = useState<string | null>(null);

    return (
        <CustomPanel title={"Snapshot Discovery"}
            canCollapse={true}
            defaultCollapsed={true}
        >
            {loading &&
                <div>
                    <Spinner label={"Loading..."} styles={{ root: { margin: '25px' } }} />
                </div>
            }
            <Stack styles={{ root: { marginTop: '10px' } }}>
                {links.map(snapshot =>
                    <Stack.Item key={snapshot.bcbs_groupconfigurationsnapshotid}>
                        <LinkTo snapshot={snapshot} />
                        {snapshot.bcbs_iseffectivedategoldstandard ? "🥈" : ""}
                        {snapshot?.statuscode === IXrmOptionSet.bcbs_groupconfigurationsnapshot.statuscode["Gold Standard(808900006)"].value ? "🥇" : ""}
                        {state.status.debug.diagnosis &&
                            <InformationCallout styles={{ root: { display: 'inline' } }}>
                                <div>
                                    <SnapshotTimeline snapshot={snapshot} />
                                </div>
                            </InformationCallout>
                        }

                    </Stack.Item>
                )}
            </Stack>
            <Link
                onClick={() => {
                    const object = { value: state.status.snapshots };

                    if (state.status.snapshots) {
                        const blob = new Blob([JSON.stringify(object)], { type: 'application/json' });
                        const url = URL.createObjectURL(blob);
                        setDocumentFile(url);
                    }
                }}>
                Show Discovery
            </Link>
            {documentFile &&
                <>
                    <iframe
                        id="snapshot-iframe"
                        style={{
                            width: '100%',
                            overflow: 'auto',
                            minHeight: '50vh',
                        }}
                        src={`./diagnosis/bcbs_groupconfigurationsnapshot.html?file=${encodeURIComponent(documentFile)}`}
                    />
                    <IconButton
                        iconProps={{ iconName: 'MiniExpand' }}
                        onClick={() => {
                            const iframe = document.getElementById("snapshot-iframe") as HTMLIFrameElement;
                            if (iframe) {
                                iframe.requestFullscreen();
                            }
                        }}
                    />

                </>
            }
        </CustomPanel>
    );

}


export default SnapshotDiscovery;